import React from "react";
import { Image, StyleSheet, Text, View, StatusBar } from "react-native";
import { connect } from "react-redux";
import { setUserLoginData } from "../../actions/user";
import { fetchToken } from "../../api";
import { encodeString } from "../../api/security";
import { STYLES } from "../../assets/styles";
import { lightenColor } from "../../common";
import Logo from "../../common/Logo";
import CustomButton from "../../components/CustomButton";
import { GUEST_CREDENTIALS } from "../../config";
import OnBoarding from "../onboarding";

function Auth({ navigation, showOnboard, loginUser }) {
  const handleNavigation = ({ route, params = {} }) => {
    navigation.navigate(route, params);
  };

  const handleSkip = () => {
    fetchToken(GUEST_CREDENTIALS).then((res) => {
      if (!res.error) {
        let currentTime = parseInt(new Date().getTime() / 1000);
        res["expiry_time"] = currentTime + res.expires_in;
        res["access_token"] = encodeString(res.access_token);
        res["is_guest"] = true;
        loginUser(res);
      }
    });
  };

  return (
    <>
      {showOnboard ? (
        <OnBoarding />
      ) : (
        <View style={{ flex: 1 }}>
          <Image
            source={require("./../../assets/images/image2.jpg")}
            style={{ height: "100%", width: "100%", position: "absolute" }}
          />
          <View
            style={{
              flex: 1,
              backgroundColor: lightenColor(STYLES.colors.black, "50"),
            }}
          >
            <View
              style={{
                padding: 10,
                marginTop: StatusBar.currentHeight,
                flexDirection: "row-reverse",
              }}
            >
              <CustomButton
                text="skip"
                textStyle={{
                  color: STYLES.colors.white,
                  fontSize: STYLES.fontSizes.medium,
                }}
                transparent={true}
                onPress={handleSkip}
                rightIcon={{ type: "AntDesign", name: "right" }}
                iconStyle={{
                  fontSize: STYLES.fontSizes.medium,
                  padding: 0,
                  color: STYLES.colors.white,
                }}
              />
            </View>
            <View style={styles.container}>
              <View
                style={{
                  width: "85%",
                }}
              >
                <Logo color={STYLES.colors.white} />
                <Text
                  style={{
                    color: STYLES.colors.white,
                    fontSize: STYLES.fontSizes.xlarge,
                    marginVertical: 20,
                  }}
                >
                  {"Sign up now \nget unlimited offers\non styles."}
                </Text>
                <CustomButton
                  text="Sign In"
                  btnStyle={{ marginVertical: 10 }}
                  onPress={() => handleNavigation({ route: "signin" })}
                />
                <CustomButton
                  text="Sign Up with Email"
                  onPress={() => handleNavigation({ route: "signup" })}
                  btnStyle={{ marginVertical: 10 }}
                  leftIcon={{
                    type: "MaterialCommunityIcons",
                    name: "email-outline",
                  }}
                />
                {/* <CustomButton
                  text="Sign in with Facebook"
                  btnStyle={{
                    marginVertical: 10,
                    backgroundColor: STYLES.colors.darkBlue,
                  }}
                  onPress={facebookSignIn}
                  iconStyle={{ color: STYLES.colors.powderWhite }}
                  textStyle={{ color: STYLES.colors.powderWhite }}
                  leftIcon={{ type: "Feather", name: "facebook" }}
                /> */}
              </View>
            </View>
          </View>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

const mapStateToProps = (state) => ({
  showOnboard: state.user.showOnboard,
});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (data) => dispatch(setUserLoginData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
